// extracted by mini-css-extract-plugin
export default {"root":"style_root__LcR-U","header":"style_header__YN+EN","content":"style_content__tYfAt"};